import React, { useEffect, useState } from 'react';
import Form from 'react-bootstrap/esm/Form';
import { useDispatch, useSelector } from 'react-redux';
import { IReducer } from '../../../../../../../../redux/configureStore';
import { setOwnershipOption } from '../../../../../../../../redux/fetchActions/legadoPage/clientsApp';
import Wrapper from '../../../../../../../../shared/components/Wrapper';

function SetOwnership() {
  const dispatch = useDispatch();
  const [isActive, setIsActive] = useState(false);
  const profileState = useSelector((reducer: IReducer) => reducer.userProfile);
  const clientsFilterState = useSelector(
    (reducer: IReducer) => reducer.clientsFilter
  );

  function SetOwnershipValue(event: React.FormEvent<any>) {
    const { value } = event.currentTarget;
    dispatch(setOwnershipOption(value));
  }

  useEffect(() => {
    if (profileState.nivel !== 2) {
      setIsActive(false);
    } else if (clientsFilterState.partner === 'todos') {
      setIsActive(true);
    } else {
      setIsActive(false);
      dispatch(setOwnershipOption('todos'));
    }
  }, [clientsFilterState.partner]);

  return (
    <Wrapper.Default isActive={isActive} flexDirection="row">
      <span>Titularidade:</span>
      <Form.Control
        as="select"
        style={{ width: '11rem', margin: '0 1rem 0 0.25rem' }}
        value={clientsFilterState.ownership}
        onChange={(event) => SetOwnershipValue(event)}>
        <option key={0} value="todos">
          Todos
        </option>
        <option key={1} value={1}>
          1 - Fiducia Scm
        </option>
        <option key={2} value={2}>
          2 - Terceiros
        </option>
      </Form.Control>
    </Wrapper.Default>
  );
}

export default SetOwnership;
